import { render, staticRenderFns } from "./ApplicantOnboardingMessage.vue?vue&type=template&id=037223d3&"
import script from "./ApplicantOnboardingMessage.vue?vue&type=script&lang=js&"
export * from "./ApplicantOnboardingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports